// Listado de contenidos
// Se definen 3 categorías (Comenzar, Administrar mi cuenta, Facturación)
function importAll(r) {
  return r.keys().map(r)
}

let articlesImport = importAll(require.context('./articles', false, /\.js$/));

let articles = articlesImport.map((articlesImport) => (articlesImport.article[0]))

export function getArticles() {
  return articles;
}

export function getArticle(articleId) {
  return articles.find(
    (article) => article.url === articleId
  );
}

// Botones de vinculo rápido
let fastLinks = [
  {
    linkId: 1,
    url: "https://www.megago.cl",
    title: "Crear cuenta",
    target: "_blank",
    external: true,
  },
  {
    linkId: 3,
    url: "https://www.megago.cl/cuenta/seleccionar",
    title: "Crear perfiles",
    target: "_blank",
    external: true,
  },
  {
    linkId: 2,
    url: "https://megago.cl/cuenta/plan",
    title: "Dar de baja",
    target: "_blank",
    external: true,
  },
  {
    linkId: 4,
    url: "https://megago.cl/cuenta",
    title: "Mi cuenta",
    target: "_blank",
    external: true,
  },
  {
    linkId: 5,
    url: "/politicas-de-privacidad",
    title: "Políticas de privacidad",
    external: false,
  },
  {
    linkId: 6,
    url: "/aun-tienes-dudas",
    title: "¿Aún tienes dudas?",
    external: false,
  }
];

export function getFastLinks() {
  return fastLinks;
}